import 'react';
import 'prop-types';
import '../types/props.js';
import { css } from 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import Button from '../Button/index.js';
import _Sidebar from 'reakit/Sidebar';

var SidebarClose = styled(Button).withConfig({
  displayName: "styled__SidebarClose",
  componentId: "sc-1lxsl4u-0"
})(["position:fixed;min-height:24px;padding:0 ", "rem;top:", "rem;", ";&:hover{color:", ";fill:", ";}&{", ";}"], space(1, 'minor'), space(2, 'minor'), function (props) {
  return props.sidebarAlign === 'left' ? css(["left:calc(", " + ", "rem);"], function (props) {
    return props.sidebarWidth;
  }, space(2, 'minor')) : css(["right:calc(", " + ", "rem);"], function (props) {
    return props.sidebarWidth;
  }, space(2, 'minor'));
}, palette('white700'), palette('white700'), theme('fannypack.Sidebar.Close.base'));
var SidebarHide = styled(_Sidebar.Hide).withConfig({
  displayName: "styled__SidebarHide",
  componentId: "sc-1lxsl4u-1"
})(["", ";"], theme('fannypack.Modal.Hide.base'));
var SidebarShow = styled(_Sidebar.Show).withConfig({
  displayName: "styled__SidebarShow",
  componentId: "sc-1lxsl4u-2"
})(["", ";"], theme('fannypack.Modal.Show.base'));
var Sidebar = styled(_Sidebar).withConfig({
  displayName: "styled__Sidebar",
  componentId: "sc-1lxsl4u-3"
})(["background-color:white;box-shadow:", " 0px 12px 0px rgba(0,0,0,0.1);width:", ";", ";"], function (props) {
  return props.align === 'left' ? '3px' : '-3px';
}, function (props) {
  return props.width;
}, theme('fannypack.Modal.base'));

export default Sidebar;
export { Sidebar, SidebarClose, SidebarHide, SidebarShow };
